import { Icon } from '@lib/components'

import styles from './styles.module.scss'

import { ConfirmMessageProps } from './types'

export const ConfirmMessage = ({
  message,
  type = 'warning',
}: ConfirmMessageProps) => {
  return (
    <div className={styles[type]}>
      <div className={styles.infoCircle}>
        <Icon
          path={type === 'info' ? 'icons/icon-info-blue' : 'icons/icon-info'}
        />
      </div>
      {message}
    </div>
  )
}
